import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../TabellaConfermaLaboratorio/TabellaConfermaLaboratorio.module.css"
import CheckBox from "../../../../../../../../../components/checkbox/CheckBox";
import Input from "../../../../../../../../../components/textbox/Input";
import Calendar from "../../../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../../../utils/Utils";
import RadioButton from "../../../../../../../../../components/radiobutton/RadioButton";
import OggettiUtili from "../../../../../../../../../utils/OggettiUtili.json"

class TabellaConfermaLaboratorio extends Component {


    constructor(props) {
        super(props);
        this.generateRadio = this.generateRadio.bind(this)
        this.createLabel = this.createLabel.bind(this)
    }

    generateRadio(id, name, label, disable, value, checked) {
        const {t} = this.props
        let radio =
            <RadioButton
                id={id}
                name={name}
                label={t(label)}
                style={{color: "black", fontSize: "16px"}}
                disabled={disable}
                newRadio={true}
                onClick={this.props.riceviValore}
                smallLabel={true}
                value={value}
                checked={checked}/>
        return radio
    }

    createLabel(text) {
        const {t} = this.props
        let asterisco = this.props.confermaDiLaboratorio.esamiEffettuati === "1" ?
            <span className={styles.mandatoryColor}>*</span> : ""
        let label =
            <th className={styles.td}>
                <p style={{fontWeight: "bold", marginLeft: "1rem", marginTop: "1rem"}}>{t(text)}{asterisco}</p>
            </th>

        return label
    }


    render() {

        const {t} = this.props

        const table = (
            <table className={styles.tableConferma}>
                <tr>
                    {this.createLabel("SchedaSpecialeMorbillo.tipoEsame")}
                    {this.createLabel("SchedaSpecialeMorbillo.dataRaccoltaCampione")}
                    {this.createLabel("SchedaSpecialeMorbillo.esito")}
                    {this.createLabel("SchedaSpecialeMorbillo.tipoDiCampione")}
                </tr>
                <tr>
                    <td className={styles.td}>
                        <div style={{marginLeft: "1rem"}}>
                            <CheckBox id={"ricercaIgm" + this.props.id}
                                      isRadio={false}
                                      checked={this.props.confermaDiLaboratorio.ricercaIgm === "true"}
                                      fontColor={"black"}
                                      fontSize={"14px"}
                                      fontWeight={"bold"}
                                      text={t("SchedaSpecialeMorbillo.ricercaIgm")}
                                      newCheckbox={true}
                                      onChange={this.props.riceviValore}
                            >
                            </CheckBox>
                        </div>
                        <div style={{marginLeft: "2rem"}}>
                            {this.generateRadio("ricercaIgmElisa" + this.props.id, "ricercaIgmElisaOAltro" + this.props.id, "SchedaSpecialeMorbillo.elisa",
                                this.props.confermaDiLaboratorio.ricercaIgm !== "true", "1", this.props.confermaDiLaboratorio.ricercaIgmElisaOAltro === "1")}
                            <div className={"row"}>
                                <div className={"col-lg-4"}>
                                    {this.generateRadio("ricercaIgmAltro" + this.props.id, "ricercaIgmElisaOAltro" + this.props.id, "SchedaSpecialeMorbillo.altro",
                                        this.props.confermaDiLaboratorio.ricercaIgm !== "true", "2", this.props.confermaDiLaboratorio.ricercaIgmElisaOAltro === "2")}
                                </div>
                                <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                    <Input id={"ricercaIgmAltroValore" + this.props.id}
                                           required={this.props.confermaDiLaboratorio.ricercaIgmElisaOAltro === "2"}
                                           onChange={this.props.riceviValore}
                                           disabled={this.props.confermaDiLaboratorio.ricercaIgmElisaOAltro !== "2"}
                                           field={"ricercaIgmAltroValore"}
                                           value={this.props.confermaDiLaboratorio.ricercaIgmAltroValore}
                                           placeholder={t("SchedaSpecialeMorbillo.altro")}
                                    />
                                </div>
                            </div>
                        </div>
                    </td>

                    <td className={styles.td}>
                        <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <Calendar
                                id={"dataRaccoltaCampioneRicergaIgm" + this.props.id}
                                value={this.props.confermaDiLaboratorio.dataRaccoltaCampioneRicergaIgm}
                                field={"dataRaccoltaCampioneRicergaIgm" + this.props.id}
                                newCalendar={true}
                                disabled={this.props.confermaDiLaboratorio.ricercaIgm !== "true"}
                                onChange={this.props.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataRaccoltaCampione"))}
                                error={(this.props.confermaDiLaboratorio.dataRaccoltaCampioneRicergaIgm === "" || this.props.confermaDiLaboratorio.dataRaccoltaCampioneRicergaIgm == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.props.confermaDiLaboratorio.dataRaccoltaCampioneRicergaIgm), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </td>
                    <td className={styles.td}>
                        <div style={{marginTop: "1rem"}}>
                            {this.generateRadio("esitoIgmPositivo" + this.props.id, "esitoRicercaIgm" + this.props.id, "SchedaSpecialeMorbillo.positivo",
                                this.props.confermaDiLaboratorio.ricercaIgm !== "true", "1", this.props.confermaDiLaboratorio.esitoRicercaIgm === "1")}
                            {this.generateRadio("esitoIgmNegativo" + this.props.id, "esitoRicercaIgm" + this.props.id, "SchedaSpecialeMorbillo.negativo",
                                this.props.confermaDiLaboratorio.ricercaIgm !== "true", "2", this.props.confermaDiLaboratorio.esitoRicercaIgm === "2")}
                            {this.generateRadio("esitoIgmBordeline" + this.props.id, "esitoRicercaIgm" + this.props.id, "SchedaSpecialeMorbillo.borderline",
                                this.props.confermaDiLaboratorio.ricercaIgm !== "true", "3", this.props.confermaDiLaboratorio.esitoRicercaIgm === "3")}

                        </div>
                    </td>
                    <td className={styles.td}>
                        {this.generateRadio("tipoCampioneIgm1" + this.props.id, "tipoCampioneRicercaIgm" + this.props.id, "SchedaSpecialeMorbillo.sieroOSangue",
                            this.props.confermaDiLaboratorio.ricercaIgm !== "true", "1", this.props.confermaDiLaboratorio.tipoCampioneRicercaIgm === "1")}
                        {this.generateRadio("tipoCampioneIgm2" + this.props.id, "tipoCampioneRicercaIgm" + this.props.id, "SchedaSpecialeMorbillo.salivaOFluidi",
                            this.props.confermaDiLaboratorio.ricercaIgm !== "true", "2", this.props.confermaDiLaboratorio.tipoCampioneRicercaIgm === "2")}
                        <div className={"row"}>
                            <div className={"col-lg-4"}>
                                {this.generateRadio("tipoCampioneIgm3" + this.props.id, "tipoCampioneRicercaIgm" + this.props.id, "SchedaSpecialeMorbillo.altro",
                                    this.props.confermaDiLaboratorio.ricercaIgm !== "true", "3", this.props.confermaDiLaboratorio.tipoCampioneRicercaIgm === "3")}
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input id={"eventualeAltroRicercaIgm" + this.props.id}
                                       onChange={this.props.riceviValore}
                                       required={this.props.confermaDiLaboratorio.tipoCampioneRicercaIgm === "3"}
                                       disabled={this.props.confermaDiLaboratorio.tipoCampioneRicercaIgm !== "3"}
                                       field={"eventualeAltroRicercaIgm" + this.props.id}
                                       value={this.props.confermaDiLaboratorio.eventualeAltroRicercaIgm}
                                       placeholder={t("SchedaSpecialeMorbillo.altro")}
                                />
                            </div>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td className={styles.td}>
                        <div style={{marginLeft: "1rem"}}>
                            <CheckBox id={"ricercaIgg" + this.props.id}
                                      isRadio={false}
                                      checked={this.props.confermaDiLaboratorio.ricercaIgg === "true"}
                                      fontColor={"black"}
                                      fontSize={"14px"}
                                      fontWeight={"bold"}
                                      text={t("SchedaSpecialeMorbillo.ricercaIgg")}
                                      newCheckbox={true}
                                      onChange={this.props.riceviValore}
                            >
                            </CheckBox>
                        </div>
                        <div style={{marginLeft: "2rem"}}>
                            {this.generateRadio("ricercaIggElisa" + this.props.id, "ricercaIggElisaOAltro" + this.props.id, "SchedaSpecialeMorbillo.elisa",
                                this.props.confermaDiLaboratorio.ricercaIgg !== "true", "1", this.props.confermaDiLaboratorio.ricercaIggElisaOAltro === "1")}
                            <div className={"row"}>
                                <div className={"col-lg-4"}>
                                    {this.generateRadio("ricercaIggAltro" + this.props.id, "ricercaIggElisaOAltro" + this.props.id, "SchedaSpecialeMorbillo.altro",
                                        this.props.confermaDiLaboratorio.ricercaIgg !== "true", "2", this.props.confermaDiLaboratorio.ricercaIggElisaOAltro === "2")}
                                </div>
                                <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                    <Input id={"ricercaIggAltroValore" + this.props.id}
                                           required={this.props.confermaDiLaboratorio.ricercaIggElisaOAltro === "2"}
                                           onChange={this.props.riceviValore}
                                           disabled={this.props.confermaDiLaboratorio.ricercaIggElisaOAltro !== "2"}
                                           field={"ricercaIggAltroValore" + this.props.id}
                                           value={this.props.confermaDiLaboratorio.ricercaIggAltroValore}
                                           placeholder={t("SchedaSpecialeMorbillo.altro")}
                                    />
                                </div>
                            </div>
                        </div>
                    </td>
                    <td className={styles.td}>
                        <div className={"row"}>
                            <div className={"col-lg-1"}>
                                <p style={{fontWeight: "bold", marginLeft: "0.5rem", marginTop: "1rem"}}>
                                    1°
                                </p>
                            </div>
                            <div className={`col-lg-10 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <Calendar
                                    id={"primaDataRaccoltaCampioneRicergaIgg" + this.props.id}
                                    value={this.props.confermaDiLaboratorio.primaDataRaccoltaCampioneRicergaIgg}
                                    field={"primaDataRaccoltaCampioneRicergaIgg" + this.props.id}
                                    newCalendar={true}
                                    disabled={this.props.confermaDiLaboratorio.ricercaIgg !== "true"}
                                    onChange={this.props.riceviValore}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataRaccoltaCampione"))}
                                    error={(this.props.confermaDiLaboratorio.primaDataRaccoltaCampioneRicergaIgg === "" || this.props.confermaDiLaboratorio.primaDataRaccoltaCampioneRicergaIgg == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.props.confermaDiLaboratorio.primaDataRaccoltaCampioneRicergaIgg), "-")
                                    }
                                >
                                </Calendar>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-lg-1"}>
                                <p style={{fontWeight: "bold", marginLeft: "0.5rem", marginTop: "1rem"}}>
                                    2°
                                </p>
                            </div>
                            <div className={`col-lg-10 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <Calendar
                                    id={"secondaDataRaccoltaCampioneRicergaIgg" + this.props.id}
                                    value={this.props.confermaDiLaboratorio.secondaDataRaccoltaCampioneRicergaIgg}
                                    field={"secondaDataRaccoltaCampioneRicergaIgg" + this.props.id}
                                    newCalendar={true}
                                    disabled={this.props.confermaDiLaboratorio.ricercaIgg !== "true"}
                                    onChange={this.props.riceviValore}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataRaccoltaCampione"))}
                                    error={(this.props.confermaDiLaboratorio.secondaDataRaccoltaCampioneRicergaIgg === "" || this.props.confermaDiLaboratorio.secondaDataRaccoltaCampioneRicergaIgg == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.props.confermaDiLaboratorio.secondaDataRaccoltaCampioneRicergaIgg), "-")
                                    }
                                >
                                </Calendar>
                            </div>
                        </div>
                    </td>
                    <td className={styles.td}>
                        <div>
                            {this.generateRadio("esitoIggPositivo" + this.props.id, "esitoRicercaIgg" + this.props.id, "SchedaSpecialeMorbillo.positivo",
                                this.props.confermaDiLaboratorio.ricercaIgg !== "true", "1", this.props.confermaDiLaboratorio.esitoRicercaIgg === "1")}
                            <span style={{
                                fontSize: "12px",
                                paddingLeft: "0.5rem"
                            }}>{t("SchedaSpecialeMorbillo.soloSe")}{t("SchedaSpecialeMorbillo.anticorpale")}</span>
                        </div>

                        <div>
                            {this.generateRadio("esitoIggNegativo" + this.props.id, "esitoRicercaIgg" + this.props.id, "SchedaSpecialeMorbillo.negativo",
                                this.props.confermaDiLaboratorio.ricercaIgg !== "true", "2", this.props.confermaDiLaboratorio.esitoRicercaIgg === "2")}
                            <span style={{
                                fontSize: "12px",
                                paddingLeft: "0.5rem"
                            }}>{t("SchedaSpecialeMorbillo.inTuttiGliAltriCasi")}</span>
                        </div>

                    </td>
                    <td className={styles.td}>
                        {this.generateRadio("tipoCampioneIgg1" + this.props.id, "tipoCampioneRicercaIgg" + this.props.id, "SchedaSpecialeMorbillo.sieroOSangue",
                            this.props.confermaDiLaboratorio.ricercaIgg !== "true", "1", this.props.confermaDiLaboratorio.tipoCampioneRicercaIgg === "1")}
                        {this.generateRadio("tipoCampioneIgg2" + this.props.id, "tipoCampioneRicercaIgg" + this.props.id, "SchedaSpecialeMorbillo.salivaOFluidi",
                            this.props.confermaDiLaboratorio.ricercaIgg !== "true", "2", this.props.confermaDiLaboratorio.tipoCampioneRicercaIgg === "2")}
                        <div className={"row"}>
                            <div className={"col-lg-4"}>
                                {this.generateRadio("tipoCampioneIgg3" + this.props.id, "tipoCampioneRicercaIgg" + this.props.id, "SchedaSpecialeMorbillo.altro",
                                    this.props.confermaDiLaboratorio.ricercaIgg !== "true", "3", this.props.confermaDiLaboratorio.tipoCampioneRicercaIgg === "3")}
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input id={"eventualeAltroRicercaIgg" + this.props.id}
                                       onChange={this.props.riceviValore}
                                       required={this.props.confermaDiLaboratorio.tipoCampioneRicercaIgg === "3"}
                                       field={"eventualeAltroRicercaIgg" + this.props.id}
                                       disabled={this.props.confermaDiLaboratorio.tipoCampioneRicercaIgg !== "3"}
                                       value={this.props.confermaDiLaboratorio.eventualeAltroRicercaIgg}
                                       placeholder={t("SchedaSpecialeMorbillo.altro")}
                                />
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className={styles.td}>
                        <div style={{marginLeft: "1rem"}}>
                            <CheckBox id={"pcr" + this.props.id}
                                      isRadio={false}
                                      checked={this.props.confermaDiLaboratorio.pcr === "true"}
                                      fontColor={"black"}
                                      fontSize={"14px"}
                                      fontWeight={"bold"}
                                      text={t("SchedaSpecialeMorbillo.pcr")}
                                      newCheckbox={true}
                                      onChange={this.props.riceviValore}
                            >
                            </CheckBox>
                        </div>
                    </td>
                    <td className={styles.td}>
                        <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}
                             style={{padding: "2rem"}}>
                            <Calendar
                                id={"dataRaccoltaCampionePcr" + this.props.id}
                                value={this.props.confermaDiLaboratorio.dataRaccoltaCampionePcr}
                                field={"dataRaccoltaCampionePcr" + this.props.id}
                                newCalendar={true}
                                disabled={this.props.confermaDiLaboratorio.pcr !== "true"}
                                onChange={this.props.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataRaccoltaCampione"))}
                                error={(this.props.confermaDiLaboratorio.dataRaccoltaCampionePcr === "" || this.props.confermaDiLaboratorio.dataRaccoltaCampionePcr == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.props.confermaDiLaboratorio.dataRaccoltaCampionePcr), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </td>
                    <td className={styles.td}>
                        {this.generateRadio("esitoPcrPositivo" + this.props.id, "esitoPcr" + this.props.id, "SchedaSpecialeMorbillo.positivo",
                            this.props.confermaDiLaboratorio.pcr !== "true", "1", this.props.confermaDiLaboratorio.esitoPcr === "1")}
                        {this.generateRadio("esitoPcrNegativo" + this.props.id, "esitoPcr" + this.props.id, "SchedaSpecialeMorbillo.negativo",
                            this.props.confermaDiLaboratorio.pcr !== "true", "2", this.props.confermaDiLaboratorio.esitoPcr === "2")}
                    </td>
                    <td className={styles.td}>
                        {this.generateRadio("tipoCampionePcr1" + this.props.id, "tipoCampionePcr" + this.props.id, "SchedaSpecialeMorbillo.sieroOSangue",
                            this.props.confermaDiLaboratorio.pcr !== "true", "1", this.props.confermaDiLaboratorio.tipoCampionePcr === "1")}
                        {this.generateRadio("tipoCampionePcr2" + this.props.id, "tipoCampionePcr" + this.props.id, "SchedaSpecialeMorbillo.salivaOFluidi",
                            this.props.confermaDiLaboratorio.pcr !== "true", "2", this.props.confermaDiLaboratorio.tipoCampionePcr === "2")}
                        {this.generateRadio("tipoCampionePcr3" + this.props.id, "tipoCampionePcr" + this.props.id, "SchedaSpecialeMorbillo.urine",
                            this.props.confermaDiLaboratorio.pcr !== "true", "3", this.props.confermaDiLaboratorio.tipoCampionePcr === "3")}
                        <div className={"row"}>
                            <div className={"col-lg-4"}>
                                {this.generateRadio("tipoCampionePcr4" + this.props.id, "tipoCampionePcr" + this.props.id, "SchedaSpecialeMorbillo.altro",
                                    this.props.confermaDiLaboratorio.pcr !== "true", "4", this.props.confermaDiLaboratorio.tipoCampionePcr === "4")}
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input id={"eventualeAltroPcr" + this.props.id}
                                       onChange={this.props.riceviValore}
                                       required={this.props.confermaDiLaboratorio.tipoCampionePcr === "4"}
                                       field={"eventualeAltroPcr" + this.props.id}
                                       disabled={this.props.confermaDiLaboratorio.tipoCampionePcr !== "4"}
                                       value={this.props.confermaDiLaboratorio.eventualeAltroPcr}
                                       placeholder={t("SchedaSpecialeMorbillo.altro")}
                                />
                            </div>
                        </div>
                    </td>
                </tr>


                <tr>
                    <td className={styles.td}>
                        <div className={"row"}>
                            <div className={"col-lg-5"} style={{marginLeft: "1rem"}}>
                                <CheckBox id={"altroTest" + this.props.id}
                                          isRadio={false}
                                          checked={this.props.confermaDiLaboratorio.altroTest === "true"}
                                          fontColor={"black"}
                                          fontSize={"14px"}
                                          fontWeight={"bold"}
                                          text={t("SchedaSpecialeMorbillo.altroTest")}
                                          newCheckbox={true}
                                          onChange={this.props.riceviValore}
                                >
                                </CheckBox>
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <Input id={"altroTestValore" + this.props.id}
                                       onChange={this.props.riceviValore}
                                       required={this.props.confermaDiLaboratorio.altroTest === "true"}
                                       field={"altroTestValore"}
                                       disabled={this.props.confermaDiLaboratorio.altroTest !== "true"}
                                       value={this.props.confermaDiLaboratorio.altroTestValore}
                                       placeholder={t("SchedaSpecialeMorbillo.altroTest")}
                                />
                            </div>
                        </div>
                    </td>
                    <td className={styles.td}>
                        <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <Calendar
                                id={"dataRaccoltaCampioneAltroTest" + this.props.id}
                                value={this.props.confermaDiLaboratorio.dataRaccoltaCampioneAltroTest}
                                field={"dataRaccoltaCampioneAltroTest" + this.props.id}
                                newCalendar={true}
                                disabled={this.props.confermaDiLaboratorio.altroTest !== "true"}
                                onChange={this.props.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataRaccoltaCampione"))}
                                error={(this.props.confermaDiLaboratorio.dataRaccoltaCampioneAltroTest === "" || this.props.confermaDiLaboratorio.dataRaccoltaCampioneAltroTest == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.props.confermaDiLaboratorio.dataRaccoltaCampioneAltroTest), "-")
                                }
                            >
                            </Calendar>
                        </div>
                    </td>
                    <td className={styles.td}>
                        {this.generateRadio("esitoAltroTestPositivo" + this.props.id, "esitoAltroTest" + this.props.id, "SchedaSpecialeMorbillo.positivo",
                            this.props.confermaDiLaboratorio.altroTest !== "true", "1", this.props.confermaDiLaboratorio.esitoAltroTest === "1")}
                        {this.generateRadio("esitoAltroTestNegativo" + this.props.id, "esitoAltroTest" + this.props.id, "SchedaSpecialeMorbillo.negativo",
                            this.props.confermaDiLaboratorio.altroTest !== "true", "2", this.props.confermaDiLaboratorio.esitoAltroTest === "2")}
                    </td>
                    <td className={styles.td}>
                        {this.generateRadio("tipoCampioneAltroTest1" + this.props.id, "tipoCampioneAltroTest" + this.props.id, "SchedaSpecialeMorbillo.sieroOSangue",
                            this.props.confermaDiLaboratorio.altroTest !== "true", "1", this.props.confermaDiLaboratorio.tipoCampioneAltroTest === "1")}
                        {this.generateRadio("tipoCampioneAltroTest2" + this.props.id, "tipoCampioneAltroTest" + this.props.id, "SchedaSpecialeMorbillo.salivaOFluidi",
                            this.props.confermaDiLaboratorio.altroTest !== "true", "2", this.props.confermaDiLaboratorio.tipoCampioneAltroTest === "2")}
                        {this.generateRadio("tipoCampioneAltroTest3" + this.props.id, "tipoCampioneAltroTest" + this.props.id, "SchedaSpecialeMorbillo.urine",
                            this.props.confermaDiLaboratorio.altroTest !== "true", "3", this.props.confermaDiLaboratorio.tipoCampioneAltroTest === "3")}
                        <div className={"row"}>
                            <div className={"col-lg-4"}>
                                {this.generateRadio("tipoCampioneAltroTest4" + this.props.id, "tipoCampioneAltroTest" + this.props.id, "SchedaSpecialeMorbillo.altro",
                                    this.props.confermaDiLaboratorio.altroTest !== "true", "4", this.props.confermaDiLaboratorio.tipoCampioneAltroTest === "4")}
                            </div>
                            <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input id={"eventualeAltroAltroTest" + this.props.id}
                                       onChange={this.props.riceviValore}
                                       required={this.props.confermaDiLaboratorio.tipoCampioneAltroTest === "4"}
                                       field={"eventualeAltroAltroTest" + this.props.id}
                                       disabled={this.props.confermaDiLaboratorio.tipoCampioneAltroTest !== "4"}
                                       value={this.props.confermaDiLaboratorio.eventualeAltroAltroTest}
                                       placeholder={t("SchedaSpecialeMorbillo.altro")}
                                />
                            </div>
                        </div>
                    </td>
                </tr>


                <tr>
                    <td className={styles.td}>
                        <div style={{marginLeft: "1rem"}}>
                            <CheckBox id={"genotipizzazione" + this.props.id}
                                      isRadio={false}
                                      checked={this.props.confermaDiLaboratorio.genotipizzazione === "true"}
                                      fontColor={"black"}
                                      fontSize={"16px"}
                                      fontWeight={"bold"}
                                      text={t("SchedaSpecialeMorbillo.genotipizzazione")}
                                      newCheckbox={true}
                                      onChange={this.props.riceviValore}
                            >
                            </CheckBox>
                        </div>
                    </td>
                    <td style={{border: "1px solid black"}} colSpan="3">
                        <div className={"row"}>
                            <div className={"col-lg-1"}>
                                <p style={{fontWeight: "bold", marginLeft: "1rem", marginTop: "1.7rem"}}>
                                    {t("SchedaSpecialeMorbillo.ceppo")}
                                    {this.props.confermaDiLaboratorio.genotipizzazione === "true" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}
                                </p>
                            </div>
                            <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                                 style={{marginTop: "1rem", marginLeft: "1rem"}}>
                                <Input id={"ceppoGenotipizzazione" + this.props.id}
                                       onChange={this.props.riceviValore}
                                       disabled={this.props.confermaDiLaboratorio.genotipizzazione !== "true"}
                                       field={"ceppoGenotipizzazione" + this.props.id}
                                       value={this.props.confermaDiLaboratorio.ceppoGenotipizzazione}
                                       placeholder={t("SchedaSpecialeMorbillo.ceppo")}
                                />
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        )

        return (
            <div className={styles.scroll}>
                {table}
            </div>
        );
    }


}

export default withTranslation('common')(TabellaConfermaLaboratorio)
